import { trackMenuClick, navigationEvents } from 'analytics';
import { navigationActions } from './actions-const';
import { setBodyScroll } from '../util/noscroll';

export function setNavigation(navigationItems) {
  return {
    type: navigationActions.SET_NAVIGATION,
    payload: navigationItems,
  };
}

export function openNavigation() {
  setBodyScroll(false);
  return {
    type: navigationActions.OPEN_NAVIGATION,
  };
}

export function closeNavigation() {
  setBodyScroll(true);
  return {
    type: navigationActions.CLOSE_NAVIGATION,
  };
}

export function toggleNavigation(source) {
  return (dispatch, getState) => {
    const {
      navigation: { isOpen },
    } = getState();
    if (isOpen) {
      trackMenuClick(navigationEvents.closeMenu, source);
      dispatch(closeNavigation());
    } else {
      trackMenuClick(navigationEvents.openMenu, source);
      dispatch(openNavigation());
    }
  };
}

export function setScrollHideNavigation() {
  return {
    type: navigationActions.SET_SCROLL_HIDE_NAVIGATION,
  };
}

export function setScrolShowNavigation() {
  return {
    type: navigationActions.SET_SCROLL_SHOW_NAVIGATION,
  };
}

export function setHasMobileHeader(hasMobileHeader) {
  return (dispatch) => {
    dispatch({
      type: navigationActions.SET_HAS_MOBILE_HEADER,
      hasMobileHeader,
    });
  };
}

export function setMobileLightNavigation(navigationItems) {
  return {
    type: navigationActions.SET_MOBILE_LIGHT_NAVIGATION,
    payload: navigationItems,
  };
}
